import { MDF_APPROVAL_FAILED, MDF_APPROVAL_REQUEST, MDF_APPROVAL_SUCCESS } from "app/redux/Approval/MdfApproval/constant";

const INIT_STATE = {
    loading: false,
    totalPage: 0,
    data: [],
    error: {
        isError: false,
        message: null
    }
};

export const mdfApprovalReducer = function (state = INIT_STATE, action) {
    switch (action?.type) {
        case MDF_APPROVAL_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null
                }
            }
        case MDF_APPROVAL_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null
                }
            }
        case MDF_APPROVAL_FAILED:
            const { isError = true, message = "Something Went Wrong" } = action?.payload?.error || {}
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message
                }
            }
        default:
            return state;
    }
};